import { type VariationColor } from '@/features/shop/services/Product/variationTypes'
import { css } from '@/features/shared/styles'
import styled from 'styled-components'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { theme } from '@/features/shared/constants/shiptTheme'

interface Props {
  variationColor: VariationColor
}

export const ProductCardColor = ({ variationColor }: Props) => {
  const { color, swatch_url, swatch_color } = variationColor

  if (swatch_url) return <ImageCircle src={swatch_url} alt={color} height={12} width={12} />

  if (swatch_color) return <ColorCircle swatch_color={swatch_color} aria-label={color} />

  return null
}

type Colors = Pick<VariationColor, 'swatch_color'>

const circle = css`
  height: 12px;
  width: 12px;
  margin-right: 4px;
  border: 1px solid ${theme.gray400};
  border-radius: 100%;
`

const ColorCircle = styled.div<Colors>`
  ${circle}
  background-color: ${({ swatch_color }) => swatch_color};
`

const ImageCircle = styled(Image)`
  ${circle}
`
